import type {CustomerProfileActivityContext} from "~/components/entityProfile/customerProfileDataSource/types";
import {ProfileCustomerActivityTimeline} from "~/components/entityProfile/activity/profileCustomerActivityTimeline";
import {
    CUSTOMER_PROFILE_OVERVIEW_ACTIVITY_PREVIEW_LIMIT,
} from "~/components/entityProfile/overview/types";
import {ProfileOverviewSectionHeader} from "~/components/entityProfile/overview/profileOverviewSectionHeader";

export function ProfileOverviewRecentActivity({
    activity,
    onSeeAll,
}: {
    activity: CustomerProfileActivityContext;
    onSeeAll?: () => void;
}) {
    return (
        <section className="grid w-full min-w-0 gap-y-ds-space-150">
            <ProfileOverviewSectionHeader
                title="Recent Activity"
                actionLabel="See all"
                onAction={onSeeAll}
            />
            <ProfileCustomerActivityTimeline
                groups={activity.groups}
                isLoading={activity.isLoading}
                isError={activity.isError}
                maxItems={CUSTOMER_PROFILE_OVERVIEW_ACTIVITY_PREVIEW_LIMIT}
            />
        </section>
    );
}
